import {
  MenuItem,
  TextField,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useConditionalVisibility } from '../../../_hooks/useConditionalVisibility';

const CustomSelectField = ({ question }) => {
  const { label, disable, selectOptions = [], size = 'small',defaultValue='', fieldId, rules, isHidden} = question;

  const { control, formState: { errors } } = useFormContext();

  const isVisible = useConditionalVisibility(question.dependantConditions, fieldId === "textPriceColumnId" );
  if (!isVisible && isHidden) return null;

  return (
    <Controller
      name={fieldId}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          select
          disabled={disable}
          size={size}
          label={label}
          error={!!errors[fieldId]}
          helperText={errors[fieldId]?.message}
          InputLabelProps={{ shrink: true }}
        >
          {selectOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};

export default CustomSelectField;
